<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav name="tab-late-fees">
                <b-nav-item @click="displayList()">
                    <i class="cus-clock-red"></i>
                    Late Fees ({{ tabCount }})
                </b-nav-item>
            </b-nav>
        </template>
        <b-card-text>
            <write-off-list
                ref="writeOffList"
                :key="keyview"
                :invoice="invoice"
                v-on="$listeners"
            />
        </b-card-text>
    </b-tab>
</template>

<script>
import WriteOffList from "@/components/invoice-latefees/latefees-list";

export default {
    components: {
        WriteOffList
    },
    data() {
        return {
            keyview: 0
            // selectedCash: null,
        };
    },
    props: {
        invoice: {
            type: Object,
            required: true
        },
        tabCount: {
            type: Number,
            default: 0
        }
    },
    methods: {
        displayList() {
            this.keyview += 1;
            this.$root.$emit("reload-count", 7);
        }
    }
};
</script>
